import React from 'react'
import { Route, Switch } from 'react-router-dom'
import AccountingNavbar from './AccountingNavbar'
import ImportCommissionStatement from './import-commission-statement/ImportCommissionStatement'
import CommissionReconciliationDashboard from './commission-reconciliation/CommissionReconciliationDashboard'
import CompensationRateGrid from './compensation-rate/CompensationRateGrid'

interface Props {
  isSideBarCollapsed: boolean
}

const Accounting: React.FunctionComponent<Props> = ({ isSideBarCollapsed }) => {
  return (
    <>
      <AccountingNavbar />
      <Switch>
        <Route
          path="/accounting/Reconciliation"
          render={() => <CommissionReconciliationDashboard />}
        />
        <Route
          path="/accounting/Import"
          render={() => (
            <ImportCommissionStatement isSideBarCollapsed={isSideBarCollapsed} />
          )}
        />
        <Route
          path="/accounting/CompensationRate"
          render={() => <CompensationRateGrid />}
        />
      </Switch>
    </>
  )
}

export default Accounting
